/* Display Judge.me's current average without replacing its rating or review count. */
(() => {
  const selector = '#judgeme_product_reviews .jdgm-rev-widg';
  const observedGalleries = new WeakSet();
  const resizeObserver = new ResizeObserver(() => updateGalleries());
  function updateGalleries() {
    document.querySelectorAll('#judgeme_product_reviews .jdgm-rev-widg__header .jdgm-gallery').forEach(gallery => {
      if (!observedGalleries.has(gallery)) {
        observedGalleries.add(gallery);
        resizeObserver.observe(gallery);
      }
      const items = [...gallery.children].filter(item => item.classList.contains('jdgm-gallery__thumbnail-link'));
      const width = gallery.clientWidth;
      if (!items.length || !width) return;
      const capacity = Math.max(1, Math.floor(width / 88));
      const visibleCount = Math.min(capacity, items.length);
      // Read the app's pagination state; leave its popup and media fetching intact.
      const state = window.jdgm?.$?.(gallery).data('gallery-data');
      const hasMore = items.length > visibleCount || (state && !state.canNotFetch);
      const tileWidth = items.length >= capacity || hasMore ? width / visibleCount : 88;
      gallery.style.setProperty('--jci-gallery-tile-width', `${tileWidth}px`);
      gallery.classList.add('jci-gallery-ready');
      items.forEach((item, index) => {
        item.classList.toggle('jci-gallery-hidden', index >= visibleCount);
        item.classList.toggle('jci-gallery-more', Boolean(hasMore) && index === visibleCount - 1);
      });
    });
  }
  function update() {
    updateGalleries();
    document.querySelectorAll(selector).forEach(widget => {
      const formWrapper = widget.querySelector('.jdgm-form-wrapper');
      const toggle = widget.querySelector('.jdgm-write-rev-link');
      if (formWrapper && toggle && !formWrapper.querySelector('.jci-review-cancel')) {
        const makeCancel = () => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'jci-review-cancel';
          button.textContent = 'Cancel review';
          button.addEventListener('click', () => {
            if (toggle.getAttribute('aria-expanded') === 'true') toggle.click();
            toggle.focus({ preventScroll: true });
            toggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          return button;
        };
        const toolbar = document.createElement('div');
        toolbar.className = 'jci-review-form-toolbar';
        toolbar.appendChild(makeCancel());
        formWrapper.prepend(toolbar);
        const submit = formWrapper.querySelector('.jdgm-submit-rev');
        if (submit) submit.insertAdjacentElement('afterend', makeCancel());
      }
      const stars = widget.querySelector('.jdgm-rev-widg__summary-stars');
      const raw = widget.getAttribute('data-average-rating');
      const rating = Number(raw);
      if (!stars || !raw || !Number.isFinite(rating) || rating < 0 || rating > 5) return;
      let label = stars.querySelector('.jci-review-average');
      if (!label) {
        label = document.createElement('span');
        label.className = 'jci-review-average';
        stars.appendChild(label);
      }
      const text = `${rating.toFixed(2)} out of 5`;
      if (label.textContent !== text) label.textContent = text;
    });
  }
  update();
  // Judge.me inserts and refreshes its widget asynchronously, including in the editor.
  new MutationObserver(update).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-average-rating']
  });
})();
